var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSetLeave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.573 17.574C17.4145 17.9246 17.1582 18.2221 16.8348 18.4306C16.5115 18.6392 16.1348 18.7501 15.75 18.75H3.75C3.21957 18.75 2.71086 18.5393 2.33579 18.1642C1.96071 17.7891 1.75 17.2804 1.75 16.75V4.75C1.74979 4.36532 1.86053 3.98874 2.06893 3.6654C2.27734 3.34206 2.57457 3.08568 2.925 2.927M6.75 2.75H15.75C16.2804 2.75 16.7891 2.96071 17.1642 3.33579C17.5393 3.71086 17.75 4.21957 17.75 4.75V13.75M13.75 0.75V4.75M5.75 0.75V1.75M1.75 8.75H8.75M12.75 8.75H17.75M8.75 12.75H9.75V15.75M0.75 0.75L18.75 18.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetLeave);
export default __webpack_public_path__ + "static/media/icon_set_leave.a2518ce9a93ad73340b7ce9cb0fb4941.svg";
export { ForwardRef as ReactComponent };